import React from 'react';

import { RequestButton } from '@common/react/components/UI/LoadingButton/LoadingButton';

interface Props {
	id: number;
	onDelete: () => void;
}

const RemoveUserFiltersButton: React.FC<Props> = ({
	onDelete, id,
}) => {
	const ref = React.useRef<HTMLDivElement>(null);
	return (
		<div className="user-filter-action__container" ref={ref}>
			<RequestButton
				requestType="userFilters"
				requestProps={{
					id,
					deleted: true,
				}}
				onSuccess={() => {
					onDelete();
				}}
				className="btn btn-default user-filter-action user-filter-action__delete"
				confirmationProps={{
					title: 'This item will be permanently deleted and cannot be recovered. Are you sure?',
					okText: 'Yes',
					okType: 'danger',
					cancelText: 'Cancel',
					getContainer: () => ref.current?.closest('.appointment-filters-tooltip-inner') || document.body,
				}}
			>
				<i className="fa fa-trash" />
			</RequestButton>
		</div>
	);
};

export default RemoveUserFiltersButton;
